import type { ChatHistoryTurn } from "@/apis/cs-rag/types";
import type { ChatMessage } from "./chat-message";

/** /chat 으로 함께 보낼 최근 대화 턴 수 상한 (백엔드 MAX_HISTORY_TURNS 와 동일, 메시지 단위). */
export const MAX_HISTORY_TURNS = 6;

/** 완료된 대화 메시지 → /chat history.
 *  - 완성된 (user 질문 → bot 답변) 쌍만 포함 → 항상 user/assistant 가 교대하고 user 로 시작
 *    (스트리밍 중·에러로 끝난 부분 답변·빈 메시지는 맥락 오염 방지를 위해 쌍째 제외)
 *  - role 은 UI "bot" → "assistant" 로 매핑
 *  - 문서명·파일명·source_id 는 넣지 않고, assistant 턴엔 인용 번호·페이지만 compact 하게 덧붙임
 *  - 최근 MAX_HISTORY_TURNS 개 메시지만 (백엔드와 동일 단위)
 *
 *  순수 함수 — firebase/axios 의존이 없어 단위 테스트 가능하도록 별도 모듈로 분리. */
export const buildHistory = (messages: ChatMessage[]): ChatHistoryTurn[] => {
  const turns: ChatHistoryTurn[] = [];
  for (let i = 0; i < messages.length - 1; i++) {
    const userMsg = messages[i];
    const botMsg = messages[i + 1];
    if (userMsg.role !== "user" || botMsg.role !== "bot") continue;
    // 정상 완료된 답변만 — 스트리밍 중·에러 종료는 제외
    if (botMsg.isStreaming || botMsg.streamError) continue;
    const question = userMsg.content?.trim();
    const answer = botMsg.content?.trim();
    if (!question || !answer) continue;

    const cites = botMsg.citations ?? [];
    const summary = cites.length
      ? "\n\n[출처 요약] " + cites.map((c) => `[${c.n}] p.${c.page}`).join(", ")
      : "";
    turns.push(
      { role: "user", content: question },
      { role: "assistant", content: answer + summary },
    );
    i++; // 쌍을 소비했으므로 다음 쌍으로
  }
  return turns.slice(-MAX_HISTORY_TURNS);
};
